import React from 'react';
import { CheckCircle, Scale } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ConnectWithSolicitors: React.FC = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/eligibility?service=immigration');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20">
            <div className="bg-[#009B8F] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">Connect with Immigration Solicitors</h1>
                    <p className="text-xl text-white/90 max-w-2xl">
                        Access to trusted, UK-registered immigration solicitors for official legal advice.
                    </p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className="p-3 bg-[#009B8F]/10 rounded-full">
                        <Scale className="text-[#009B8F] w-8 h-8" />
                    </div>
                    <h2 className="text-3xl font-serif text-[#011E26]">Professional Legal Support</h2>
                </div>

                <div className="prose prose-lg text-slate-600 max-w-none">
                    <p className="mb-4">
                        Our Connect with Immigration Solicitors service provides students with access to trusted, UK-registered immigration solicitors who can offer official legal advice on visa applications and related matters. This service is currently available only for students applying to the UK, ensuring that guidance is fully compliant with UK immigration law.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#009B8F] mb-8">
                        <h3 className="text-lg font-bold text-[#011E26] mb-3 uppercase tracking-wide">Through this service, students can:</h3>
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {[
                                "Receive timely legal advice from qualified and trusted UK solicitors",
                                "Ensure they are applying for the right visa type for their specific situation",
                                "Get support with complex applications or special circumstances, reducing the risk of errors or refusals",
                                "Stay informed and compliant with all legal requirements and procedural rules throughout the application process"
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-2 text-sm font-medium">
                                    <CheckCircle className="w-5 h-5 text-[#009B8F] flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p className="mb-4">
                        At NexOverseas, we act as a bridge between students and solicitors, making it easy to connect with professionals who understand the UK immigration system and can provide accurate, reliable, and timely guidance. By leveraging this service, students gain confidence, clarity, and peace of mind, knowing that their applications are handled correctly under the guidance of registered legal experts.
                    </p>

                    <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-6">
                        <p className="text-amber-800 text-sm font-medium">
                            <strong>Note:</strong> This service is currently available only for students applying to the UK.
                        </p>
                    </div>

                    <button
                        onClick={handleContactClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Get in Touch Today
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConnectWithSolicitors;
